<template lang="pug">
aside.monitoring-detail

    //- MODAL
    div.overlay-close(
        v-if="cmptDisplayModal"
        @click="closeForm()")

    div.modal(
        v-if="displayTransferForm || displayVolumeAlertForm || displayEditSingleInput.bootstrap"
        :class="classModal")
        FormTransfers(
            v-if="displayTransferForm"
            :selectedAudience="audienceInfo")
        FormBootstrapAudience(
            v-else-if="displayEditSingleInput.bootstrap"
            :selectedAudience="audienceInfo"
            :editBootstrap='editAudienceInfo'
            :closeModal="closeBootstrapModal")
        MonitoringFormVolumeAlert(
            v-else-if="displayVolumeAlertForm"
            :selectedAudience="audienceInfo")

    Panel.l-flex-column(panelClassName="monitoring-details-panel")
        template(slot="header")
            sectionHeader(title="details")
                template(slot="action")
                    div.section-header--action
                    div.section-header--action

        //- DEFAULT
        template(slot="content", v-if="selectedAudienceId === null")
            div.info-content.scrollbar.is-scrollable
                div.info-block.total
                    div.label Audiences
                    div.value {{ audiencesListInfo.total }}
                div.info-block
                    div.label Active
                    div.value {{ audiencesListInfo.active }}
                div.info-block
                    div.label Inactive
                    div.value {{ audiencesListInfo.inactive }}
                div.info-block
                    div.label Shared
                    div.value {{ audiencesListInfo.shared }}
                div.info-block
                    div.label Transfers
                    div.value {{ audiencesListInfo.transfers }}
            //- div.info-block
            //-     div {{ transfersListInfo.total }} Transfers
            //- div.info-block
            //-     div.label Active
            //-     div.value {{ transfersListInfo.active }}
            //- div.info-block
            //-     div.label Inactive
            //-     div.value {{ transfersListInfo.inactive }}


        //- AUDIENCE DETAILS
        template(slot="content", v-else)
            //- TABS
            Tabs.info-tabs(:dataTabs="dataTabs", parent="audiences")

                //- TAB DETAILS
                template(slot="content", v-if="activeTab === 'information'")
                    MonitoringInfos(:audienceInfo="audienceInfo" @displayEditSingleInputBootstrap="displayEditSingleInputBootstrap()")

                //- TAB METRICS
                template(slot="content" v-if="activeTab === 'metrics'")
                    MonitoringMetrics(:audienceInfo="audienceInfo")

                //- TAB BREAKDOWN
                template(slot="content", v-if="activeTab === 'breakdown'")
                    div.tab-content.scrollbar.is-scrollable
                        MonitoringBreakdown(parent="monitoring")

                //- TAB TRANSFER
                template(slot="content", v-if="activeTab === 'transfers'")
                    MonitoringTransfers(:audienceInfo="audienceInfo")
                //- Sharing tab
                template(slot="content", v-if="this.activeTab === 'sharing'")
                    div.tab-content
                        SharingAudiences

        template(slot="footer" v-if="isFooter")
            //- Delete audience
            .delete-audience.btn.btn-delete.btn--medium.btn--round.l-flex-row--center.l-align-center(@click="deleteAudienceHandler()")
                svg-icon(name='trash' size='small')
                | Delete audience


</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import { isEmpty, isEqual, pick, get, isNil, size, join, filter } from 'lodash'

import { totalTransfers, totalItemsByStatus } from '@/utils/helpers'
import dayjs from 'dayjs'

import { AUDIENCES_DATATABS } from '@/utils/constants'

import MonitoringBreakdown from './MonitoringBreakdown.vue'

// Componentspick
import Breakdown from '@/components/common/Breakdown'
import FormBootstrapAudience from '@/components/monitoring/FormBootstrapAudience'
import FormTransfers from '@/components/monitoring/FormTransfers'
import MonitoringFormVolumeAlert from '@/components/monitoring/MonitoringFormVolumeAlert'
import Panel from '@/components/common/Panel'
import Tabs from '@/components/common/Tabs'
import SectionHeader from '@/components/common/SectionHeader'
import SharingAudiences from '@/components/monitoring/SharingAudiences'
import MonitoringTransfers from '@/components/monitoring/MonitoringTransfers'
import MonitoringMetrics from '@/components/monitoring/MonitoringMetrics'
import MonitoringInfos from '@/components/monitoring/MonitoringInfos'

export default {
    name: 'Details',

    components: {
        Breakdown,
        FormBootstrapAudience,
        FormTransfers,
        MonitoringFormVolumeAlert,
        Panel,
        Tabs,
        SharingAudiences,
        MonitoringTransfers,
        MonitoringMetrics,
        MonitoringInfos,
        SectionHeader,
        MonitoringBreakdown,
    },

    props: {
        audienceInfo: { type: Object, required: false, default: () => ({}) }
    },

    data() {
        return {
            displayEditSingleInput: {
                label: false,
                endDate: false,
                email: false,
                cc: false,
                tags: false,
                bootstrap: false
            },
            audienceFormLabel: null,
            audienceFormEndDate: null,
            audienceFormEmail: null,
            audienceFormCc: [],
            audienceTagsList: [],
            transferFormEndDate: {},
            transferFormLabel: {},
            transferFormCc: [],
            transferFormEmail: {}
            //- @TODO IMPROVE EDIT INLINE - Don't remove commented code below
            // emptyTransferLabel: false,
            // emptyTransferEndDate: false,
            // emptyTransferEmail: false,
        }
    },

    created() {
        // Retrieveing sharings so we can make sure if we need to display the sharing tabs or not
        if (isEmpty(this.sharingAudiencesAccounts)) this.retrieveLinkedAccounts()

        //- @TODO IMPROVE EDIT INLINE - Don't remove commented code below
        // Below is commented, it's seem unuseful
        // if (this.audienceInfo) this.updateTransferData()
        // elspicke console.error('this.audienceInfo is not defined')
    },

    watch: {
        activeTab: {
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    //check if audience volume details are already in store, if selected tab has changed and if AudienceVolumeChart is displayed
                    if (isEmpty(pick(this.audienceDetails, this.selectedAudienceId)) && newValue === 'metrics') {
                        this.retrieveAudienceVolumeFromAudience({ audienceId: this.selectedAudienceId })
                        this.retrieveVolumeAlert({ audienceId: this.selectedAudienceId })
                    }
                    if (newValue === 'breakdown' && this.audienceInfo && isEmpty(this.audienceInfo.breakdown)) {
                        this.handleRetrieveAudienceBreakdown()
                    }
                }
            }
        },
        selectedAudienceId: {
            handler: function(newValue, oldValue) {
                if (!isNil(newValue) && !isEqual(newValue, oldValue)) {
                    this.setSelectedAudienceHaveDeletedCriteria({ result: false })
                    //to check if bootstrap start and push of stock buttons must be disabled or not
                    this.retrieveAttributionCounterAudience()
                    this.retrieveAttributionCounterTransfer()

                    // retrieve generic formula total_doc volumes if not already in store
                    if (!this.hasGenericFormulaTotalDocVolumesInStore && isNil(this.audienceInfo.sharedAudience)) {
                        this.processStatistics({ type: 'volumes', formula: this.audienceInfo.formula, version: 1, audienceId: newValue })
                    }

                    //checks for chart data retrieval && breakdown retrieval OR summary
                    if (this.activeTab === 'breakdown') {
                        this.handleRetrieveAudienceBreakdown()
                    } else if (this.activeTab === 'sharing') {
                        if (!this.sharedAudiences[this.selectedAudienceId]) {
                            this.retrieveSharedAudiences({ audienceId: this.selectedAudienceId })
                        }
                    }
                }
            }
        },
        demographicBreakdown: {
            handler: function(newValue) {
                if (this.activeTab === 'breakdown' && !newValue) {
                    this.setActiveTab({ tab: 'information' })
                }
            },
            deep: true
        }
    },

    computed: {
        // Call to state

        // UI
        ...mapState('ui/monitoring', {
            activeTab: state => state.activeTab,
            filteredData: state => state.filteredData,
            selectedAudienceId: state => state.selectedRowId,
            genericFormulaVolumes: state => state.formulaVolumes
        }),

        ...mapState('ui/settings', {
            demographicBreakdown: state => state.general.demographicBreakdown
        }),

        ...mapState('ui/transfers', {
            displayTransferForm: state => state.showFormTransfer
        }),
        ...mapState('ui/volumeAlert', {
            displayVolumeAlertForm: state => state.showForm
        }),

        // DATA
        ...mapState('data/settings', {
            sharingAudiencesAccounts: state => state.sharing.audiences
        }),
        ...mapState('data/transfer', {
            transferList: state => state.list
        }),
        ...mapState('data/audience', {
            audienceList: state => state.list,
            audienceDetails: state => state.audienceDetails
        }),
        ...mapState('data/sharedAudience', {
            sharedAudiences: state => state.list
        }),
        // Call to getters
        ...mapGetters('data/transfer', ['getTransfersByAudienceList']),
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),

        //volumes
        hasGenericFormulaTotalDocVolumesInStore() {
            return !isNil(this.selectedAudienceId) && this.genericFormulaVolumes.hasOwnProperty(this.selectedAudienceId)
        },

        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },

        cmptDisplayModal() {
            return this.displayEditSingleInput.bootstrap || this.displayTransferForm || this.displayVolumeAlertForm
        },

        //transfers for all filtered (or not) audiences
        _transferList() {
            return isNil(this.filteredData) || size(this.filteredData) === size(this.audienceList)
                ? this.transferList
                : this.getTransfersByAudienceList({ audienceList: this.filteredData })
        },

        //table audiences
        audiencesListInfo() {
            const baseList = isNil(this.filteredData) ? this.audienceList : this.filteredData
            return {
                total: size(baseList),
                active: totalItemsByStatus(baseList, 'active'),
                inactive: totalItemsByStatus(baseList, 'inactive'),
                shared: size(baseList.filter(item => !isNil(item.sharedAudience))),
                transfers: totalTransfers(this._transferList)
            }
        },

        // Footer
        isFooter() {
            return this.activeTab === 'information' && this.monitoringActionAllowed && this.selectedAudienceId !== null
        },

        classModal() {
            let _classModal = ''
            if (this.displayTransferForm) _classModal = 'modal-h-full modal__medium modal-form-transfer'
            else if (this.displayExportForm) _classModal = 'modal-h-auto modal__medium modal-form-export'
            else if (this.displayVolumeAlertForm) _classModal = 'modal-h-auto modal__medium'
            else if (this.displayEditSingleInput.bootstrap) _classModal = 'modal-h-auto modal__small modal-formBootstrapAudience'

            return _classModal
        },

        activeSharingAccounts() {
            return filter(this.sharingAudiencesAccounts, account => account.audience_sharing === 'active')
        },

        dataTabs() {
            const conditionalTabs = []

            if (!isEmpty(this.activeSharingAccounts)) conditionalTabs.push({ label: 'sharing' })
            if (this.demographicBreakdown) conditionalTabs.push({ label: 'breakdown' })
            return AUDIENCES_DATATABS.concat(conditionalTabs)
        }
    },

    methods: {
        // Call to actions
        ...mapActions('data/audience', ['retrieveAudienceInfos', 'retrieveAudienceVolumeFromAudience', 'editAudience', 'retrieveVolumeAlert']),
        ...mapActions('data/settings', ['retrieveLinkedAccounts']),
        ...mapActions('data/transfer', ['editTransfer']),
        ...mapActions('ui/builder', ['processStatistics']),
        ...mapActions('account', ['retrieveAttributionCounterAudience', 'retrieveAttributionCounterTransfer']),
        ...mapActions('data/sharedAudience', ['retrieveSharedAudiences']),
        // Call to mutations
        ...mapMutations('exports', ['setExportForm']),
        ...mapMutations('ui/transfers', ['setShowFormTransfer']),
        ...mapMutations('ui/monitoring', ['setDisplayModal', 'setActiveTab', 'setDeletedAudienceId', 'setSelectedAudienceHaveDeletedCriteria']),
        ...mapMutations('ui/volumeAlert', ['setDefaultVolumeAlertForm']),

        /**
         * Trigger vuex action to get audience summary
         */
        handleRetrieveAudienceSummary() {
            this.retrieveAudienceInfos({
                type: 'summary',
                audienceId: this.audienceInfo.id,
                formula: this.audienceInfo.formula
            })
        },

        /**
         * Trigger vuex action to get audience breakdown
         */
        handleRetrieveAudienceBreakdown() {
            this.retrieveAudienceInfos({
                type: 'breakdown',
                audienceId: this.audienceInfo.id,
                formula: {
                    ids: [this.audienceInfo.id],
                    name: `audience_${this.audienceInfo.id}`,
                    type: 'Audience',
                    recency: '30'
                }
            })
        },

        // EXPORT DATA
        closeForm() {
            this.setDefaultVolumeAlertForm()
            this.setExportForm({ display: false, type: '' })
            this.setShowFormTransfer({ show: false })
            this.displayEditSingleInput = {
                tags: false,
                bootstrap: false
            }
            // reset
            if (this.selectedAudienceId) {
                if (this.activeTab === 'information') {
                    this.audienceFormLabel = this.audienceInfo.label
                    this.audienceFormEndDate = dayjs(this.audienceInfo.endDate).format('YYYY-MM-DD')
                    this.audienceFormEmail = this.audienceInfo.email
                    this.audienceFormCc = isEmpty(this.audienceInfo.cc) ? [] : this.audienceInfo.cc.split(',')
                } else if (this.activeTab === 'transfers') {
                    this.transferFormLabel = {}
                    this.transferFormEndDate = {}
                    this.transferFormEmail = {}
                    this.transferFormCc = []
                }
            }
        },

        // Modal single edit
        displayEdit(field, transfer) {
            if (this.monitoringActionAllowed) {
                if (transfer) {
                    // edit transfer
                    if (field === 'label') this.transferFormLabel = { ...this.transferFormLabel, [transfer.id]: transfer.label }
                    else if (field === 'endDate') this.transferFormEndDate = { ...this.transferFormEndDate, [transfer.id]: transfer.end_date }
                    else if (field === 'email') this.transferFormEmail[transfer.id] = transfer.email
                    else if (field === 'cc') this.transferFormCc = isEmpty(transfer.cc) ? [] : transfer.cc.split(',')

                    if (!isNil(get(this.displayEditSingleInput[field], 'id', null))) {
                        this.displayEditSingleInput[field][transfer.id] = true
                    } else {
                        this.displayEditSingleInput[field] = { [transfer.id]: true }
                    }
                } else {
                    this.displayEditSingleInput[field] = true //edit audience
                }
            }
        },

        editAudienceInfo(dataToEdit, newValue) {
            const {
                audienceFormLabel,
                audienceFormEndDate,
                audienceFormEmail,
                audienceFormCc,
                audienceInfo,
                selectedAudienceId,
                audienceTagsList,
                editAudience
            } = this

            const { displayEditSingleInput } = this

            if (this.monitoringActionAllowed) {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        let _params
                        if (dataToEdit === 'endDate') _params = { params: { end_date: audienceFormEndDate }, notificationMessage: 'The date has been modified' }
                        else if (dataToEdit === 'email') _params = { params: { email: audienceFormEmail }, notificationMessage: 'The email has been modified' }
                        else if (dataToEdit === 'cc')
                            _params = { params: { email_cc: join(audienceFormCc, ',') }, notificationMessage: 'The email_cc has been modified' }
                        else if (dataToEdit === 'label') _params = { params: { label: audienceFormLabel }, notificationMessage: 'The label has been modified' }
                        else if (dataToEdit === 'bootstrap')
                            _params = { params: newValue, notificationMessage: 'The bootstrap ' + audienceInfo.label + ' has been added' }
                        else if (dataToEdit === 'audience-status') {
                            // if audience is set inactive, don't change the end date
                            if (!newValue) _params = { params: { status: 'inactive' }, notificationMessage: audienceInfo.label + ' has been set inactive' }
                            else {
                                const today = new Date()
                                const _endDate = new Date(audienceFormEndDate)
                                if (today.getTime() === _endDate.getTime() || _endDate < today) {
                                    // if audience is set active and the end date is today or before, change the end date (+ 30 days)
                                    const newEndDate = today.setDate(today.getDate() + 30)
                                    _params = {
                                        params: { status: 'active', end_date: dayjs(newEndDate).format('YYYY-MM-DD') },
                                        notificationMessage: audienceInfo.label + ' has been set active'
                                    }
                                } else {
                                    // if audience is set active and the end date after today, don't change the end date
                                    _params = { params: { status: 'active' }, notificationMessage: audienceInfo.label + ' has been set active' }
                                }
                            }
                        }

                        editAudience({ ..._params, id: selectedAudienceId, tags: audienceTagsList })

                        // close edit modal
                        if (dataToEdit !== 'audience-status') {
                            displayEditSingleInput[dataToEdit] = false
                        }
                    }
                })
            }
        },

        closeBootstrapModal() {
            this.displayEditSingleInput.bootstrap = false
        },
        deleteAudienceHandler() {
            this.setDisplayModal({ item: 'audience', display: true })
            this.setDeletedAudienceId({ audienceId: this.selectedAudienceId })
        },
        displayEditSingleInputBootstrap() {
            this.displayEditSingleInput.bootstrap = true
        }

        // @TODO IMPROVE EDIT INLINE - Don't remove commented code below
        // editTransferInfo(transferId, transferURL, dataToEdit, newValue, event) {
        //     const { transferFormLabel, transferFormEndDate, transferFormEmail, transferFormCc, selectedAudienceId, editTransfer } = this
        //     let { displayEditSingleInput, emptyTransferLabel, emptyTransferEndDate, emptyTransferEmail } = this

        //     // empty fields
        //     if (transferFormLabel[transferId] === '') emptyTransferLabel = true
        //     if (isNil(transferFormEndDate[transferId])) emptyTransferEndDate = true
        //     if (transferFormEmail[transferId] === '') emptyTransferEmail = true

        //     if (!emptyTransferEndDate && !emptyTransferLabel && !emptyTransferEmail) {
        //         this.$validator.validateAll().then(isValid => {
        //             if (isValid) {
        //                 let _params
        //                 if (dataToEdit === 'endDate') {
        //                     _params = { params: { end_date: transferFormEndDate[transferId] }, notificationMessage: 'The date has been modified' }
        //                 } else if (dataToEdit === 'cc')
        //                     _params = { params: { cc: join(transferFormCc, ',') }, notificationMessage: 'The email_cc has been modified' }
        //                 else if (dataToEdit === 'label')
        //                     _params = { params: { label: transferFormLabel[transferId] }, notificationMessage: 'The label has been modified' }
        //                 else if (dataToEdit === 'email')
        //                     _params = { params: { email: transferFormEmail[transferId] }, notificationMessage: 'The email has been modified' }
        //                 else if (dataToEdit === 'pixelUrlRandom') {
        //                     if (!newValue) {
        //                         //remove random param from pixel_url
        //                         _params = {
        //                             params: { pixel_url: this.removeRandomParam(transferURL) },
        //                             notificationMessage: 'The random parameter has been disabled'
        //                         }
        //                     } else {
        //                         //add random param from pixel_url
        //                         _params = {
        //                             params: { pixel_url: this.addRandomParam(transferURL) },
        //                             notificationMessage: 'The random parameter has been enabled'
        //                         }
        //                     }
        //                 }

        //                 editTransfer({ ..._params, audienceId: selectedAudienceId, id: transferId })

        //                 // close edit modal
        //                 if (dataToEdit !== 'pixelUrlRandom') displayEditSingleInput[dataToEdit] = false
        //             }
        //         })
        //     } else {
        //         if (emptyTransferLabel) this.resetTransferInfo('label', event)
        //         if (emptyTransferEndDate) this.resetTransferInfo('end_date', event)
        //         if (emptyTransferEmail) this.resetTransferInfo('email', event)
        //     }
        // },
        //
        // resetTransferData(param) {
        //     for (let transfer of this.selectedAudienceTransfers) {
        //         if (param === 'end_date') {
        //             this.transferFormEndDate = { ...this.transferFormEndDate, [transfer.id]: transfer.end_date }
        //         }
        //         if (param === 'email') {
        //             this.transferFormEmail = { ...this.transferFormEmail, [transfer.id]: transfer.email }
        //         }
        //         if (param === 'label') {
        //             this.transferFormLabel = { ...this.transferFormLabel, [transfer.id]: transfer.label }
        //         }
        //     }
        // },
        //
        // resetTransferInfo(param, event) {
        //     this.resetTransferData(param)
        //     event.target.blur()
        //     this.errors.clear()
        //     this.emptyTransferLabel = this.emptyTransferEndDate = this.emptyTransferEmail = false
        // },
    }
}
</script>
